export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";